export default __webpack_public_path__ + "static/media/(13).0e0ecdca.jpeg";